import { useLocationsByName } from '@hakimo-ui/hakimo/data-access';
import { LocationFilterValue } from '@hakimo-ui/hakimo/types';
import MultiSelectFilter from '../multi-select-filter/MultiSelectFilter';

interface Props {
  value: LocationFilterValue;
  label: string;
  enableNegativeFilters?: boolean;
  onChange: (value: LocationFilterValue) => void;
}

export function LocationFilter(props: Props) {
  const { value, label, enableNegativeFilters = false, onChange } = props;
  const getLocationsByName = useLocationsByName();

  return (
    <MultiSelectFilter
      value={value}
      label={label}
      enableNegativeFilters={enableNegativeFilters}
      onChange={onChange}
      getOptions={getLocationsByName}
    />
  );
}

export default LocationFilter;
